import Vue from 'vue';
import Vuelidate from 'vuelidate';
import { required, numeric, minValue, requiredIf } from 'vuelidate/lib/validators';
import datePicker from '../../../components/forms/component.date-picker.vue';
import ageSwitch from '../../../components/forms/component.age-birthdate-input-switch.vue';
import { MainVueOpts } from '../../../main-vue';
import {
    isAfterField,
    monthDate,
    dateNotInFuture,
    createDateByLangStr,
    onlyAlphaNumeric,
    convertDateByLang,
    createDateByLangApplications,
    numbersWithDashSlash,
    noAlphabets,
    requireChildrenAndOthers
} from '../../../helper-functions/helper-functions';
import {
    createUpdateApplicationService,
    changeInSessionStorage,
    goToFirstError,
    hideValidationsWhileTyping,
    setItemSessionStorage,
    getItemSessionStorage
} from '../../../helper-functions/services';
import Step1Mixin from '../mixins/Step1Mixin';
import { trawickConfig } from '../../../helper-functions/app-configs';
import { trawickPlanIds } from './shared';

Vue.use(Vuelidate);

const repurchaseOptions = {
    SAME_PLAN_DIFF_PERSON: '1',
    DIFF_PLAN_DIFF_PERSON: '3'
}

export default {
    mixins: [MainVueOpts, Step1Mixin],
    components: {
        'date-picker': datePicker,
        'age-switch': ageSwitch
    },
    props: ['form-data'],
    data: function () {
        return {
            travelerLimit: 100,
            // Safe Travels Complete asks for the destination date of arrival, like IMG Visitors Protect.
            // Vue merges this with Step1Mixin's form, so startDate/endDate/travelerInfos are untouched.
            form: {
                arrivalDateUS: ibJS.application?.arrivalDateUS || ''
            },
            setDate: '',
            isSafeTravelsComplete: trawickConfig.isSafeTravelsComplete(),
            formSending: false,
            previousLoading: false,
            showMobileError: false,
            showEndDateError: false,
            showPrimaryValidation: false,
            showHomeCountryQuestion: false,
            homeCountryOption: ibJS.application ? ibJS.application.homeCountryUs : '',
            disableApplication: false,
            showPrimaryValidationForTripCost: false,
            showSecondaryValidationForTripCost: false,
            showSecondaryValidationForAge: false,
            submitted: false,
            initialTripDepositDate: ibJS.application ? ibJS.application.initialTripDepositDate : null,
            residenceState: ibJS.application ? ibJS.application.homeCountryAddress ? ibJS.application.homeCountryAddress?.state : '' : '',
            isTripProtectPlans: trawickConfig.isTripProtectPlans(),
            isNationWidePlans: trawickConfig.isNationWidePlans(),
            isVoyagerPlans: trawickConfig.isVoyagerPlans(),
            isSTfrstClsPlans: trawickConfig.isSTfrstClsPlans(),
            isSTSingleTrip: trawickConfig.isSTSingleTrip(),
            isExplorerPlans: trawickConfig.isExplorerPlans(),
            isOutboundCost: trawickConfig.isOutboundCost(),
            triggerAllTravelerValidation: false,
            UserLoggedInMyAcoount: ibJS.UserLoggedInMyAcoount,
            hasChildfromQuote: false,
            hasSpousefromQuote: false,
            numOfChildFromQuote: 0,
            destination: '',
            currentLang: window.globalLanguage.lang,
            destInclCostaRica: getItemSessionStorage.call(this,'destInclCostaRica') !== undefined ? getItemSessionStorage.call(this,'destInclCostaRica') : ''
        }
    },
    validations: function () {
        var validations = {
            form: {
                startDate: {
                    monthDate,
                    numbersWithDashSlash,
                    noAlphabets,
                    required
                },
                endDate: {
                    required,
                    monthDate,
                    numbersWithDashSlash,
                    noAlphabets,
                    isAfterStartDate: isAfterField('startDate', this.submitted)
                },
                travelerInfos: {
                    $each: {
                        age: { 
                            requiredChild,
                            childAge,
                            spouseAge,
                            minValue: minValue(0)
                        },
                        tripCost: {}
                    }
                },
                homeCountryOption: {},
                arrivalDateUS: {
                    required: requiredIf(() => this.isSafeTravelsComplete),
                    monthDate,
                    numbersWithDashSlash,
                    noAlphabets
                }
            },
            residenceState: {},
            destination: {},
            initialTripDepositDate: {},
            destInclCostaRica:{}
        };

        if (this.isVoyagerPlans || this.isExplorerPlans) validations.destination.required = required;

        if (this.isVoyagerPlans || this.isExplorerPlans || this.isSTfrstClsPlans || this.isSTSingleTrip || this.isOutboundCost) validations.residenceState.requried = required;

        this.showEndDateError = this.form.endDate === '';

        function childAge(x,a){
            return  true;
        }

        function spouseAge(x,a){
            if(x !== '' && x !== null) {
                return true;    
            }
            return true;
        }

        var ageIndex = -1;
        function requiredChild(x,a) {
            ageIndex += 1;  
            if (this.hasChildfromQuote && !this.hasSpousefromQuote && this.numOfChildFromQuote == 1 && ageIndex == 1 ) {
                /* 1 child + 0 spouse*/
                return (x === '' || x === null) ? false : true;
            } else {
                return this.form.travelerInfos.length > 3 && (x === '' || x === null) ? false : true;
            }
            
        }

        if(this.hasChildfromQuote && this.hasSpousefromQuote && this.numOfChildFromQuote == 1) {
            /* 1 child + 1 spouse from quote*/
            validations.form.travelerInfos.$each.age.required = required;
        } else if(this.hasChildfromQuote && !this.hasSpousefromQuote && this.numOfChildFromQuote == 2) {
            /* 2 children + 0 spouse from quote*/
            validations.form.travelerInfos.$each.age.required = required;
        } else if(this.isMobile) {
            validations.form.travelerInfos.$each.age.required = required;
        }

        if (this.form.startDate !== '' && this.form.endDate !== '') {
            var startDate = createDateByLangStr(this.form.startDate, 'en');
            var endDate = createDateByLangStr(this.form.endDate, 'en');
        }

        if (this.isFromQuoteResults) {
            validations.form.travelerInfos.$each.age.spouseAge = spouseAge;
            validations.form.travelerInfos.$each.age.requiredChild = requiredChild;
            validations.form.travelerInfos.$each.age.childAge = childAge;
        }

        if (this.tripCancellationPlans) {
            validations.initialTripDepositDate = { required, onlyAlphaNumeric, monthDate, dateNotInFuture };

            // SUPDT - 419
            let tripCostError = {};
            if(this.form.planId === 634 || this.isSTSingleTrip || this.form.planId === 506 || this.form.planId === trawickPlanIds.Safe_Travels_First_Class_Parent || this.form.planId === trawickPlanIds.Safe_Travels_First_Class_All_Other_States || this.form.planId === trawickPlanIds.Safe_Travels_First_Class_Penn_Alaska_Missouri) {
                tripCostError = { requireChildrenAndOthers, numeric};
            } else if (this.form.planId === trawickPlanIds.SafeTreker_Parent ) {
                tripCostError = { requireChildrenAndOthers, numeric};
            } else if (this.isVoyagerPlans || this.isExplorerPlans) {
                tripCostError = { requireChildrenAndOthers, numeric, minValue: minValue(0) };
            } else {
                tripCostError = { requireChildrenAndOthers, numeric, minValue: minValue(1) };
            }
            
            validations.form.travelerInfos.$each.tripCost = tripCostError;

            validations.form.travelerInfos.$each.age.required = required;
            validations.form.travelerInfos.$each.tripCost.required = required;

        }

        if(this.hasDestCostaRica && this.destInclCostaRica=='') {
            validations.destInclCostaRica.required = required;
        } else {
            delete validations.destInclCostaRica.required;
        }

        return validations;
    },
    created: function () {
        var self = this;

        // earliest selectable destination arrival date (Safe Travels Complete), same as IMG
        const todaysDate = new Date();
        this.setDate = new Date(`${todaysDate.getMonth()+1}/${todaysDate.getDate()}/${todaysDate.getFullYear()}`);

        if(self.application != null){
            if (ibJS.application.destinationCountries?.[0]?.country) {
                this.destination = ibJS.application.destinationCountries?.[0]?.country;
            }

            if(this.application.travelerInfos !== null && this.application.travelerInfos.length) {
                self.form.travelerInfos =[];
                /* only primary and spouse have age value*/
                let ageGreaterThanZero = 0;
                for(var i=0;i<self.application.travelerInfos.length;i++){
                    let currentTraveler = self.application.travelerInfos[i];
                    var newTraveler = {
                        age: currentTraveler.age,
                        tripCost: getTripCost.call(this, currentTraveler),
                        quotePrice:null,
                        travelerType:currentTraveler.travelerType
                    };

                    self.form.travelerInfos.push(newTraveler);
                    if(currentTraveler && self.form.travelerInfos[i].age==-1) {
                        this.hasChildfromQuote = true;
                        this.numOfChildFromQuote += 1;
                    }

                    if(currentTraveler && self.form.travelerInfos[i].age > 0) {
                        ageGreaterThanZero += 1;
                    }
                }
                if(ageGreaterThanZero === 2) {
                    this.hasSpousefromQuote = true;
                }
            }

            if(!this.tripCancellationPlans) {
                if (self.form.travelerInfos && Array.isArray(self.form.travelerInfos) && self.form.travelerInfos.length === 1 && !self.isMobile) {
                    var traveler1 = {
                        age: null,
                        tripCost: null,
                        quotePrice: null,
                        travelerType: ''
                    };
                    var traveler2 = {
                        age: null,
                        tripCost: null,
                        quotePrice: null,
                        travelerType: ''
                    };
                    self.form.travelerInfos.push(traveler1);
                    self.form.travelerInfos.push(traveler2);
                } else if (self.form.travelerInfos && Array.isArray(self.form.travelerInfos) && self.form.travelerInfos.length === 2 && !self.isMobile) {
                    var traveler = {
                        age: null,
                        tripCost: null,
                        quotePrice: null,
                        travelerType: ''
                    };
                    self.form.travelerInfos.push(traveler);
                }    
            } else if (this.application.travelerInfos.length < 1 && (ibJS.option === repurchaseOptions.SAME_PLAN_DIFF_PERSON || ibJS.option === repurchaseOptions.DIFF_PLAN_DIFF_PERSON)) {
                self.form.travelerInfos = self.form.travelerInfos.slice(0,1);
            }
            
            self.travelersOpened = true;

            // When coming from the quote results and children are present. Asks to input child age
            for (var i = 0; i < self.form.travelerInfos.length; i++) {
                if (self.form.travelerInfos[i].age == -1) {
                    self.form.travelerInfos[i].age = null;
                    self.showTravelers = true;
                }
            }
        } else {
            if((self.tripCancellationPlans) && self.form.travelerInfos && self.form.travelerInfos.length > 1) {
                // For trip plan, only keep one blank traveler
                self.form.travelerInfos = self.form.travelerInfos.slice(0,1);
            }    
        }

        if(getItemSessionStorage("safeTrekerSession")){
            let safeTrekerSessionVal = getItemSessionStorage("safeTrekerSession");
            if(safeTrekerSessionVal && safeTrekerSessionVal !== "undefined"){
                this.form = JSON.parse(safeTrekerSessionVal);
                if(window.ibJS && window.ibJS.planId) {
                    this.form.planId = window.ibJS.planId;
                }
                this.initialTripDepositDate = this.form.initialTripDepositDate;
                /* one time use for safetreker plan switch */
                sessionStorage.removeItem("safeTrekerSession");
            }
        }

        $(document).ready(function () {
            $('.o-Form').on('click', function () {
                self.showTravelers = false;
            });

            $('.js-Stop-propagation').on('click', function (e) {
                e.stopPropagation();
            });
        });

        /**
         * When coming from purchase again -> all trip costs are null/empty
         * when coming from step2 or saved app -> we keep original trip cost
         */
        function getTripCost(currentTraveler) {
            if (ibJS.repurchaseFromMyaccount) {
                return null
            } else {
                return currentTraveler.tripCost || 0;
            }
        }
    },
    watch: {
        'form.startDate': function () {
            this.showMobileError = false;
        },
        'form.endDate': function () {
            this.showMobileError = false;
        },
        'form.arrivalDateUS': function () {
            this.showMobileError = false;
        },
        initialTripDepositDate: function () {
            this.showMobileError = false;
        },
        residenceState: function () {
            this.showMobileError = false;
        },
        destination: function () {
            this.showMobileError = false;
        },
        'form.travelerInfos': function () {
            Vue.nextTick(() => {
                this.addInputFocusOutline();
            });
        },
        'destInclCostaRica' : function(val) {
            changeInSessionStorage.call(this,'destInclCostaRica',this.destInclCostaRica);

            if(val === 'No' && ibJS.affiliateValues.trawickTripCanNW) {
                window.location.href = window.qResultsLang.costaRicaLanding;
            }
        }
    },
    mounted: function () {
        this.addInputFocusOutline();
        convertDateByLang(this.form, window.globalLanguage.lang);
        hideValidationsWhileTyping(['initialTripDepositDate']);
    },
    computed: {
        // travelerTripCostShowValidation: function () {
        //     let isVisible = false;

        //     if (this.form.travelerInfos.length <= 3) {
        //         if (!this.form.travelerInfos[2].tripCost && !this.form.travelerInfos[2].age) {
        //             isVisible = false;
        //         } else {
        //             isVisible = true;
        //         }
        //     } else {
        //         isVisible = true;
        //     }

        //     return isVisible;
        // }
        hasDestUS: function() {
            if(this.destination && this.destination === 'USA') {
                return true;
            }
        },
        tripCancellationPlans () {
            return this.isNationWidePlans || this.isTripProtectPlans || this.isVoyagerPlans || this.isExplorerPlans;
        },
        hasDestCostaRica() {
            // if(this.form.planId === trawickPlanIds.Safe_Travels_Explorer_Plus || this.form.planId === trawickPlanIds.Safe_Travels_Journey) {
            //     return this.destination === 'CRI';
            // }
            return false;
        },
        costaRicaRestriction() {
            if (this.hasDestCostaRica && this.destInclCostaRica === 'No') return true;
        },
        disableContinue() {
            return this.showMobileError || this.$v.$error;
        },
        isTripInsurance() {
            return [506, 583, 634, 635, 636, 724, 689, 725, 726, 727, 756, 757].indexOf(this.formData.planId) > -1;
        }
    },
    methods: {
        createQuote: function (e) {
            e.preventDefault();

            var error = false;
            this.showPrimaryValidation = false;

            this.$v.$touch();

            if (this.form.travelerInfos && this.form.travelerInfos.length && (this.form.travelerInfos[0].age === null || this.form.travelerInfos[0].age === '')) {
                error = true;
                this.showPrimaryValidation = true;
            }

            if (!this.$v.$invalid && error === false && !this.showEndDateError && (this.homeCountryOption === '' || this.homeCountryOption === 'No')) {
                for (var k = 1; k < this.form.travelerInfos.length; k++) {
                    if (!this.showPrimaryValidation && (this.form.travelerInfos[k].age === null || this.form.travelerInfos[k].age === '')) {
                        this.form.travelerInfos.splice(k, 1);
                        k -= 1;
                    }
                }
            }

            var quoteResultsURL = '/api/' + ibJS.productName + '/quote-results/?lang=' + window.globalLanguage.lang;

            if (!this.$v.$invalid && !error && !this.showEndDateError) {
                var _this = this;

                this.spliceTravelers();

                if (this.tripCancellationPlans) this.form.initialTripDepositDate = this.initialTripDepositDate;

                if(this.isVoyagerPlans || this.isExplorerPlans || this.isSTfrstClsPlans || this.isSTSingleTrip || this.isOutboundCost) {
                    this.form.homeCountryAddress = {
                        state: this.residenceState
                    };
                }

                Vue.nextTick(() => {
                    _this.hideDateError = true;
                    this.form.destinationStr = [this.destination];
                    let langBasedData = Object.assign({}, this.form);
                    createDateByLangApplications(langBasedData, window.globalLanguage.lang);
                    if (this.tripCancellationPlans) {
                        const keepDefaultTraveler = true;
                        createUpdateApplicationService.call(this, quoteResultsURL, langBasedData, 'application', keepDefaultTraveler); // if default is one traveler pass the last parameter as true
                    } else {
                        createUpdateApplicationService.call(this, quoteResultsURL, langBasedData, 'application');
                    }
                    this.submitted = true;
                });
                this.submitted = false;
                _this.hideDateError = false;
            } else {
                Vue.nextTick(() => goToFirstError());
                this.showMobileError = true;
            }
        },
        addTraveler: function () {
            var newTraveler = {
                tripCost: null,
                age: null,
                travelerType: ''
            };

            if (this.tripCancellationPlans) {
                this.triggerAllTravelerValidation = true;
            }
            this.form.travelerInfos.push(newTraveler);
        },
        resetAgeValidation: function (index) {
            if (this.form.travelerInfos[index] && !(/^\d+$/.test(this.form.travelerInfos[index].age))) {
                this.form.travelerInfos[index].age = null;
            }
            if (index === 0) {
                this.showPrimaryValidation = false;
            } else if (index === 1) {
                this.showSecondaryValidationForAge = false;
            } else if (index > 1) {
                this.showSecondaryValidationForAge = false;
            }

            // adding the trip cost check for resetting the errors after input

            if (this.form.travelerInfos[index] && !(/^\d+$/.test(this.form.travelerInfos[index].tripCost))) {
                this.form.travelerInfos[index].tripCost = null;
            }

            if (index === 0) {
                this.showPrimaryValidationForTripCost = false;
            }
            if (index > 0) {
                this.showSecondaryValidationForTripCost = false;
            }
            this.showMobileError = false;
        },
        resetForm: function (e) {
            this.form.startDate = '';
            this.form.endDate = '';

            this.form.travelerInfos = [
                {
                    age: null,
                    tripCost: null,
                    travelerType: ''
                },
                {
                    age: null,
                    tripCost: null,
                    travelerType: ''
                },
                {
                    age: null,
                    tripCost: null,
                    travelerType: ''
                }
            ];
            this.travelersOpened = false;
            this.formSending = false;
            this.previousLoading = false;
            this.showMobileError = false;
            this.showPrimaryValidation = false;
            this.showHomeCountryQuestion = false;
            this.homeCountryOption = '';
            this.$v.$reset();
            this.$emit('resubmit');
            this.hasChildfromQuote=false;
            this.hasSpousefromQuote=false;
            this.numOfChildFromQuote=0;
            e.preventDefault();
        },
        setRedirectData: function (planId) {
            let sessionData = Object.assign({}, this.form);
            if(planId == trawickPlanIds.SafeTreker_Extreme) {
                sessionData.planId = trawickPlanIds.SafeTreker_Extreme_Plus;
            } else if (planId == trawickPlanIds.SafeTreker_Extreme_Plus) {
                sessionData.planId = trawickPlanIds.SafeTreker_Extreme;
            }
            setItemSessionStorage("safeTrekerSession", JSON.stringify(sessionData));
        },
        addInputFocusOutline: function () {
            //Manually add focus for trip cxl partial border inputs
            if (document.getElementsByClassName('input-check')[0]) {
                Array.prototype.forEach.call(document.getElementsByClassName('input-check'), (x, i) => {

                    const index = Math.floor(i / 2);
                    const partialBodyClass = document.getElementsByClassName('partial-border-split-half')[index];

                    x.addEventListener('focus', () => {
                        partialBodyClass.classList.add('multiselect-focus');
                        if (this.tripCancellationPlans) {
                            partialBodyClass.style.padding = '5px 0';
                        }

                    });
                    x.addEventListener('blur', () => {
                        partialBodyClass.classList.remove('multiselect-focus');
                        if (this.tripCancellationPlans) {
                            partialBodyClass.removeAttribute('style');
                        }
                    });
                });
            }
        },
        spliceTravelerForTrip: function ($index) {
            this.clickedDelete = true;
            this.showOtherErrorText = false;
            if (this.showMobileError) {
                this.showMobileError = false
            }
            this.form.travelerInfos.splice($index, 1);
            let isTouched = false;
            if (this.form.travelerInfos.length === 3) {
                for (var i = 1; i < this.form.travelerInfos.length; i++) {
                    if ((this.form.travelerInfos[i].age != null && this.form.travelerInfos[i].age.toString().trim() !== "")
                        || (this.form.travelerInfos[i].tripCost != null && this.form.travelerInfos[i].tripCost.toString().trim() !== "")) {
                        isTouched = true;
                        break;
                    }
                }
                if (isTouched === false) {
                    this.triggerAllTravelerValidation = false;
                }
            }
        }
    }
};
